// extracted by mini-css-extract-plugin
module.exports = {"Steps":"Steps-module__Steps___2TXZI","middleSteps":"Steps-module__middleSteps___2Kx-8"};